import { ScreenAssistantGuide } from '@dms/screen'

export default ScreenAssistantGuide
